

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VenueMaster } from '../models/venuemaster';
import { Department } from '../models/department';

@Injectable({
  providedIn: 'root'
})
export class VenueMasterService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'venue/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllVenue(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllVenue?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewVenue(Venue_Id?: string): Observable<Array<VenueMaster>> {
      return this.httpService.get(this.apiEndpoint + '/viewVenue/' + (Venue_Id ? Venue_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveVenue(VenueMaster: VenueMaster): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveVenue/', VenueMaster).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteVenue(Venue_Id?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteVenue/' + (Venue_Id ? Venue_Id : '00000000-0000-0000-0000-000000000000'), Venue_Id).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(VenueName?: string,Venue_Id?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?VenueName=' + (VenueName ? VenueName : '')+ '&Venue_Id=' + (Venue_Id ? Venue_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    }


  
  }

